// services/everpro/everpro-order/cancel.ts — batalkan order Everpro (single + bulk) via S2 proxy
import { everproFetch } from '../everpro-auth';

export interface BulkCancelResult {
  successCount: number;
  failedCount: number;
  details: Array<{ orderNumber?: string; awbNumber?: string; status?: string; message?: string }>;
}

export async function cancelEverproOrder(
  orderIdentifier: string,
  cancelReason: string,
  brandId: string,
): Promise<void> {
  if (!brandId) throw new Error('Everpro: brandId wajib');

  const res = await everproFetch(
    brandId,
    `/shipment/v1/orders/${encodeURIComponent(orderIdentifier)}/cancel`,
    {
      method: 'POST',
      body: JSON.stringify({ cancel_reason: cancelReason }),
    },
  );

  if (!res.ok) {
    const detail = await res.text().catch(() => '');
    let message = '';
    try { message = JSON.parse(detail).message || ''; } catch { /* */ }
    throw new Error(message || `Everpro cancel: ${res.status} ${res.statusText}`);
  }
}

export async function bulkCancelEverproOrders(
  awbNumbers: string[],
  cancelReason: string,
  brandId: string,
): Promise<BulkCancelResult> {
  if (!brandId) throw new Error('Everpro: brandId wajib');
  if (!awbNumbers.length) return { successCount: 0, failedCount: 0, details: [] };

  const res = await everproFetch(brandId, '/shipment/v1/orders/bulk-cancel', {
    method: 'PUT',
    body: JSON.stringify({ awb_numbers: awbNumbers, cancel_reason: cancelReason }),
  });

  if (!res.ok) {
    const detail = await res.text().catch(() => '');
    let message = '';
    try { message = JSON.parse(detail).message || ''; } catch { /* */ }
    throw new Error(message || `Everpro bulk cancel: ${res.status} ${res.statusText}`);
  }

  const json = await res.json();
  const data = json?.data ?? {};
  return {
    successCount: Number(data.success_count) || 0,
    failedCount: Number(data.failed_count) || 0,
    details: Array.isArray(data.details) ? data.details : [],
  };
}
